import { useCallback, useRef } from 'react';

export const useDataBlockRefs = () => {
    const searchRef = useRef<HTMLBdsInputElement>(null);
    const pendingPageSizeRef = useRef<number | null>(null);
    const abortControllerRef = useRef<AbortController | null>(null);
    const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const clearSearch = useCallback(() => {
        searchRef.current?.clear();
    }, []);

    const getSearchTerm = useCallback(async () => {
        const element = await searchRef.current?.getInputElement();
        return element?.value?.toLocaleLowerCase() || '';
    }, []);

    const createNewAbortController = useCallback(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();
        return abortControllerRef.current;
    }, []);

    const setDebounceTimeout = useCallback((callback: () => void, delay = 300) => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        debounceTimeoutRef.current = setTimeout(callback, delay);
    }, []);

    return {
        searchRef,
        pendingPageSizeRef,
        clearSearch,
        getSearchTerm,
        createNewAbortController,
        setDebounceTimeout,
    };
};
